export default __webpack_public_path__ + "static/media/z630ma0a.3b1f57e0.mp3";